// Read-only physical-page pairing. No pagination, PDF or source mutations.
// Page 1 appears on the RIGHT; then leaves are (2,3), (4,5), etc.
export function novelApprovedSpreadCount(totalPages) {
  const n = Number(totalPages);
  return Number.isInteger(n) && n > 0 ? 1 + Math.ceil((n - 1) / 2) : 0;
}

export function novelApprovedSpread(totalPages, index) {
  const count = novelApprovedSpreadCount(totalPages);
  if (!count) return { left: null, right: null, index: 0, count: 0 };
  const position = Math.max(0, Math.min(count - 1, Math.trunc(Number(index) || 0)));
  if (position === 0) return { left: null, right: 1, index: 0, count };
  const left = position * 2;
  const right = left + 1 <= totalPages ? left + 1 : null;
  return { left, right, index: position, count };
}
